import React from 'react';

interface CalculateComponentProps {
  otherWidth: number;
  otherHeight: number;
  windowChange: (contentWidth: number, contentHeight: number) => void;
}

/**
 * 区域自适应宽高组件
 */
class CalculateComponent extends React.Component<CalculateComponentProps> {
  //   constructor(props) {
  //     super(props);
  //   }

  componentDidMount() {
    window.addEventListener('resize', this.resizeUpdate);
    this.resizeUpdate();
  }

  componentWillUnmount() {
    // 离开页面时移除监听事件
    window.removeEventListener('resize', this.resizeUpdate);
  }

  resizeUpdate = () => {
    const { otherWidth, otherHeight, windowChange } = this.props;
    let contentWidth = window.innerWidth && window.innerWidth - otherWidth;
    let contentHeight = window.innerHeight && window.innerHeight - otherHeight;

    // 兼容工作台处理，减去Header及SideMenu宽高
    contentHeight = contentHeight - 56 - 32 - 16;

    contentWidth = contentWidth - 200 - 48;

    if (windowChange) {
      windowChange(contentWidth, contentHeight);
    }
  };

  render() {
    return <div style={{ display: 'none' }} />;
  }
}

export default CalculateComponent;
